import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getCurtainTrack } from '../../../helpers/getCurtainTrack';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  option: string,
  pleatType: string,
  fitting: string,
  context: ProductBuilderMachineContext,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (option, pleatType, fitting, context, send) => () => {
  const curtainTrack = getCurtainTrack(option, pleatType, fitting, context);

  const track = `${option}:${curtainTrack.id}`;
  const trackPrice = curtainTrack.price;

  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      track,
      trackPrice,
    },
  });
};

export const Track = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const trackTypes = baseProduct ? baseProduct.metafields.track || [] : [];
  const {
    custom: { track, pleatType, fitting },
  } = state.context;
  const productType = getBaseProductType(state.context);

  if (!Array.isArray(trackTypes) || trackTypes.length === 0) {
    if (isCurrentState('track', state)) {
      throwError(state);
    }
  }

  return (
    <SectionContent>
      <Heading>Track</Heading>
      <Selector isSlider={true}>
        {trackTypes.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'track',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={
                option ===
                (typeof track !== 'undefined' ? track.split(':')[0] : '')
              }
              onClick={onClick(option, pleatType, fitting, state.context, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
      {typeof track !== 'undefined' &&
        track.split(':')[0] === 'Double Track' && (
          <Caption>
            When placing an order for 2 curtains with double tracks only one of
            the curtains needs to have double tracks selected. The other may be
            ordered with no track
          </Caption>
        )}
    </SectionContent>
  );
};
